/*
 * @Author: 朱亚
 * @Date: 2020-10-10 10:19:09
 * @说明：根据参数，控制loading是否显示
 */
const install = Vue => {
  if (install.installed) return
  install.installed = true
  const toast = text => Vue.$vux.toast.show({ text, type: 'text' })
  const loading = text => {
    if (text === undefined) Vue.nextTick(() => Vue.$vux.loading.hide())
    else Vue.$vux.loading.show({ text })
  }
  Object.defineProperties(Vue.prototype, {
    $toast: {
      get() {
        return toast
      }
    },
    $loading: {
      get() {
        return loading
      }
    }
  })
}
export default { install }



// WEBPACK FOOTER //
// ./src/plugins/showToast.js